import { BI_PAGE_NAMES } from '../../../../../shared/services/BIEvents/constants';
import { EXPERT_LISTINGS_SOURCE } from '../../generic_listings/ExpertListingsContainer/constants';

export const getBiPageName = (isExpertListings) => (isExpertListings ? EXPERT_LISTINGS_SOURCE : BI_PAGE_NAMES.LISTINGS);
